export const TOTAL_STEPS = 2;

export const PAGE_TITLE = 'Ajouter une prestation';

export const STEP_LABELS: Record<1 | 2, string> = {
  1: 'Prestation',
  2: 'Ressources',
};

export const ADD_PRESTATION_SUCCESS = 'La prestation a été ajoutée avec succès';
export const ADD_PRESTATION_ALREADY_EXISTS =
  'Cette prestation est déjà rattachée au bénéficiaire.';
export const NO_AVAILABLE_SERVICE_MESSAGE =
  "Aucune prestation disponible n'a pu être trouvée pour ce consultant.";
export const NO_CONSULTANT_MESSAGE = "Aucun consultant actif n'a été trouvé.";
